import { render, staticRenderFns } from "./DocumentLayout.vue?vue&type=template&id=d727e482&"
import script from "./DocumentLayout.vue?vue&type=script&lang=js&"
export * from "./DocumentLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports